(function() {
    'use strict';
    
    // Attendre que l'éditeur soit prêt
    if (typeof wp === 'undefined' || typeof wp.domReady === 'undefined') {
        return;
    }

    // Fonction d'initialisation qui fonctionne dans Gutenberg et dans l'admin classique
    function initACFBlockPreview() {
        // Récupérer l'URL du thème depuis les données localisées
        const themeUrl = (typeof acfBlockPreview !== 'undefined' && acfBlockPreview.themeUrl) 
            ? acfBlockPreview.themeUrl 
            : '';
        
        if (!themeUrl) {
            console.error('ACF Block Preview: Theme URL not found!');
        } else {
            console.log('ACF Block Preview: Theme URL:', themeUrl);
        }

        // Fonction pour obtenir le nom du bloc depuis le nom ACF
        function getBlockNameFromACF(blockName) {
            // Les blocs ACF ont le format "acf/block-name"
            if (blockName && blockName.startsWith('acf/')) {
                return blockName.replace('acf/', '');
            }
            return null;
        }

        // Fonction pour convertir le nom du layout flexible en nom de dossier
        function getFolderNameFromLayout(layoutName) {
            // Les layouts flexibles ont le format "m_quote", "m_header", etc.
            // On retire le préfixe "m_" pour obtenir le nom du dossier
            if (layoutName && layoutName.startsWith('m_')) {
                return layoutName.replace('m_', '');
            }
            return layoutName;
        }

        // Fonction pour obtenir le chemin de l'image du bloc
        function getBlockImagePath(blockName) {
            const cleanName = getBlockNameFromACF(blockName);
            if (!cleanName || !themeUrl) return null;
            
            // Convertir les tirets en underscores pour correspondre aux noms de fichiers
            const fileName = cleanName.replace(/-/g, '_');
            
            // Chercher l'image dans /dist/img/preview/
            const basePath = themeUrl + '/dist/img/preview/' + fileName;
            
            // Essayer aussi avec .jpg et .svg
            return {
                png: basePath + '.png',
                jpg: basePath + '.jpg',
                svg: basePath + '.svg'
            };
        }

        // Fonction pour obtenir le chemin de l'image du layout flexible
        function getLayoutImagePath(layoutName) {
            if (!layoutName || !themeUrl) return null;
            
            // Convertir le nom du layout en nom de dossier
            const folderName = getFolderNameFromLayout(layoutName);
            
            // Chercher l'image dans /dist/img/preview/
            const basePath = themeUrl + '/dist/img/preview/' + folderName;
            
            // Essayer aussi avec .jpg et .svg
            return {
                png: basePath + '.png',
                jpg: basePath + '.jpg',
                svg: basePath + '.svg'
            };
        }

        // Fonction pour créer le tooltip
        function createPreviewTooltip(blockName, isLayout, iconElement) {
            const imagePaths = isLayout ? getLayoutImagePath(blockName) : getBlockImagePath(blockName);
            if (!imagePaths) {
                return null;
            }

            const tooltip = document.createElement('div');
            tooltip.className = 'acf-block-preview-tooltip';
            
            // Créer l'image avec gestion d'erreur améliorée
            const img = document.createElement('img');
            img.className = 'acf-block-preview-tooltip__image';
            img.alt = 'Aperçu du bloc ' + blockName;
            
            // Essayer de charger l'image dans l'ordre : png, jpg, svg
            let currentIndex = 0;
            const formats = ['png', 'jpg', 'svg'];
            
            img.onerror = function() {
                currentIndex++;
                if (currentIndex < formats.length) {
                    const format = formats[currentIndex];
                    img.src = imagePaths[format];
                } else {
                    img.style.display = 'none';
                    const container = tooltip.querySelector('.acf-block-preview-tooltip__image-container');
                    if (container) {
                        container.innerHTML = '<p>Image non trouvée</p>';
                    }
                }
            };
            
            // Commencer par PNG
            img.src = imagePaths.png;
            
            tooltip.innerHTML = `
                <div class="acf-block-preview-tooltip__image-container">
                </div>
            `;
            
            // Ajouter l'image au container
            const container = tooltip.querySelector('.acf-block-preview-tooltip__image-container');
            if (container) {
                container.appendChild(img);
            }

            // Positionner le tooltip près de l'icône
            // On doit d'abord ajouter le tooltip au DOM (temporairement invisible) pour obtenir ses dimensions
            tooltip.style.visibility = 'hidden';
            tooltip.style.display = 'block';
            document.body.appendChild(tooltip);
            const iconRect = iconElement.getBoundingClientRect();
            const tooltipRect = tooltip.getBoundingClientRect();
            
            // Positionner en bas à droite de l'icône par défaut
            let top = iconRect.bottom + 5;
            let left = iconRect.left;
            
            // Vérifier si le tooltip dépasse à droite
            if (left + tooltipRect.width > window.innerWidth) {
                left = window.innerWidth - tooltipRect.width - 10;
            }
            
            // Vérifier si le tooltip dépasse en bas
            if (top + tooltipRect.height > window.innerHeight) {
                top = iconRect.top - tooltipRect.height - 5;
            }
            
            // S'assurer que le tooltip ne dépasse pas en haut
            if (top < 0) {
                top = iconRect.bottom + 5;
            }
            
            // Retirer temporairement du DOM pour le repositionner correctement
            tooltip.remove();
            
            // Repositionner avec les bonnes coordonnées
            tooltip.style.top = top + window.scrollY + 'px';
            tooltip.style.left = left + window.scrollX + 'px';
            tooltip.style.visibility = 'visible';
            tooltip.style.display = 'block';

            return tooltip;
        }

        // Fonction pour ajouter l'icône "?" au bloc
        function addPreviewIcon(blockElement, blockName) {
            // Vérifier si l'icône existe déjà
            if (blockElement.querySelector('.acf-block-preview-icon')) {
                return;
            }

            // Chercher l'en-tête du bloc dans le panneau latéral ACF
            // Plusieurs sélecteurs possibles selon la structure ACF
            let targetElement = null;
            
            // Essayer de trouver dans le panneau latéral (InspectorControls)
            const inspectorControls = document.querySelector('.block-editor-block-inspector .acf-block-component');
            if (inspectorControls) {
                // Chercher le label du premier champ de groupe
                targetElement = inspectorControls.querySelector('.acf-fields > .acf-field-group > .acf-label label');
                if (!targetElement) {
                    targetElement = inspectorControls.querySelector('.acf-fields > .acf-field-group > .acf-label');
                }
                if (!targetElement) {
                    // Chercher dans le header du panneau
                    targetElement = inspectorControls.querySelector('.acf-block-fields .acf-fields > .acf-field-group > .acf-label label');
                }
            }
            
            // Si pas trouvé dans l'inspector, chercher dans le bloc lui-même
            if (!targetElement) {
                targetElement = blockElement.querySelector('.acf-block-component .acf-block-fields .acf-fields > .acf-field-group > .acf-label label');
            }
            if (!targetElement) {
                targetElement = blockElement.querySelector('.acf-block-component .acf-block-fields .acf-fields > .acf-field-group > .acf-label');
            }
            
            // Si toujours pas trouvé, chercher dans le panneau latéral général
            if (!targetElement) {
                const sidebar = document.querySelector('.interface-complementary-area');
                if (sidebar) {
                    // Chercher le titre du bloc dans le panneau latéral
                    const blockTitle = sidebar.querySelector('[data-type="' + blockName + '"] .acf-block-component .acf-fields > .acf-field-group > .acf-label label');
                    if (blockTitle) {
                        targetElement = blockTitle;
                    }
                }
            }

            if (!targetElement) {
                return;
            }

            const icon = document.createElement('span');
            icon.className = 'acf-block-preview-icon';
            icon.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/></svg>';
            icon.title = 'Aperçu du bloc';
            
            let modalTimeout;
            let currentModal = null;
            
            icon.addEventListener('mouseenter', function(e) {
                clearTimeout(modalTimeout);
                // Supprimer le tooltip existant si il existe
                if (currentModal) {
                    currentModal.remove();
                    currentModal = null;
                }
                const tooltip = createPreviewTooltip(blockName, false, icon);
                if (tooltip) {
                    // Le tooltip est déjà dans le DOM (ajouté temporairement pour calculer les dimensions)
                    // On le réajoute s'il a été retiré
                    if (!document.body.contains(tooltip)) {
                        document.body.appendChild(tooltip);
                    }
                    currentModal = tooltip;
                    
                    // Garder le tooltip ouvert quand on survole le tooltip
                    tooltip.addEventListener('mouseenter', function() {
                        clearTimeout(modalTimeout);
                    });
                    
                    tooltip.addEventListener('mouseleave', function() {
                        modalTimeout = setTimeout(function() {
                            if (currentModal) {
                                currentModal.remove();
                                currentModal = null;
                            }
                        }, 150);
                    });
                }
            });
            
            icon.addEventListener('mouseleave', function() {
                modalTimeout = setTimeout(function() {
                    if (currentModal && !currentModal.matches(':hover')) {
                        currentModal.remove();
                        currentModal = null;
                    }
                }, 150);
            });

            targetElement.appendChild(icon);
        }

        // Fonction pour ajouter les icônes de preview dans le popup de sélection de layout
        function addPreviewIconsToPopup() {
            // Essayer plusieurs sélecteurs pour trouver le popup
            let popup = document.querySelector('.acf-tooltip.acf-fc-popup');
            if (!popup) {
                popup = document.querySelector('.acf-fc-popup');
            }
            if (!popup) {
                popup = document.querySelector('.acf-tooltip');
            }
            
            if (!popup) {
                return;
            }
            
            // Chercher tous les li dans le popup
            const allItems = popup.querySelectorAll('li');
            
            allItems.forEach(function(li) {
                // Vérifier si l'icône existe déjà
                if (li.querySelector('.acf-block-preview-icon')) {
                    return;
                }
                
                // Essayer de récupérer le layout name depuis différents endroits
                let layoutName = li.getAttribute('data-layout');
                
                if (!layoutName) {
                    const link = li.querySelector('a');
                    if (link) {
                        layoutName = link.getAttribute('data-layout');
                    }
                }
                
                if (!layoutName) {
                    return;
                }
                
                addIconToPopupItem(li, layoutName);
            });
        }
        
        // Fonction pour ajouter l'icône à un élément du popup
        function addIconToPopupItem(li, layoutName) {
            // Vérifier si l'icône existe déjà
            if (li.querySelector('.acf-block-preview-icon')) {
                return;
            }
            
            // Créer l'icône
            const icon = document.createElement('span');
            icon.className = 'acf-block-preview-icon';
            icon.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/></svg>';
            icon.title = 'Aperçu du layout';
            
            let modalTimeout;
            let currentModal = null;
            
            icon.addEventListener('mouseenter', function(e) {
                e.stopPropagation();
                clearTimeout(modalTimeout);
                // Supprimer le tooltip existant si il existe
                if (currentModal) {
                    currentModal.remove();
                    currentModal = null;
                }
                const tooltip = createPreviewTooltip(layoutName, true, icon);
                if (tooltip) {
                    // Le tooltip est déjà dans le DOM (ajouté temporairement pour calculer les dimensions)
                    // On le réajoute s'il a été retiré
                    if (!document.body.contains(tooltip)) {
                        document.body.appendChild(tooltip);
                    }
                    currentModal = tooltip;
                    
                    // Garder le tooltip ouvert quand on survole le tooltip
                    tooltip.addEventListener('mouseenter', function() {
                        clearTimeout(modalTimeout);
                    });
                    
                    tooltip.addEventListener('mouseleave', function() {
                        modalTimeout = setTimeout(function() {
                            if (currentModal) {
                                currentModal.remove();
                                currentModal = null;
                            }
                        }, 150);
                    });
                }
            });
            
            icon.addEventListener('mouseleave', function(e) {
                e.stopPropagation();
                modalTimeout = setTimeout(function() {
                    if (currentModal && !currentModal.matches(':hover')) {
                        currentModal.remove();
                        currentModal = null;
                    }
                }, 150);
            });
            
            // Ajouter l'icône dans le li (après le texte du layout)
            const link = li.querySelector('a');
            if (link) {
                // Insérer l'icône dans le lien (à droite)
                link.appendChild(icon);
            } else {
                // Sinon, ajouter à la fin du li
                li.appendChild(icon);
            }
        }
        
        // Observer pour détecter les nouveaux blocs ajoutés
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        // Chercher les blocs ACF
                        const acfBlocks = node.querySelectorAll ? node.querySelectorAll('[data-type^="acf/"]') : [];
                        acfBlocks.forEach(function(block) {
                            const blockName = block.getAttribute('data-type');
                            if (blockName) {
                                // Attendre un peu pour que le DOM soit complètement chargé
                                setTimeout(function() {
                                    addPreviewIcon(block, blockName);
                                }, 100);
                            }
                        });
                        
                        // Vérifier si c'est le popup qui s'ouvre
                        if (node.classList && (node.classList.contains('acf-tooltip') || node.classList.contains('acf-fc-popup'))) {
                            setTimeout(function() {
                                addPreviewIconsToPopup();
                            }, 50);
                        }
                        
                        // Vérifier si le popup est dans le node
                        const popup = node.querySelector ? node.querySelector('.acf-tooltip.acf-fc-popup') : null;
                        if (popup) {
                            setTimeout(function() {
                                addPreviewIconsToPopup();
                            }, 50);
                        }
                    }
                });
            });
        });

        // Fonction pour ajouter l'icône aux layouts flexibles
        function addPreviewIconToLayouts() {
            // Chercher tous les .acf-fc-layout-actions-wrap dans tout le document
            // ACF peut les mettre dans différents endroits (panneau latéral ou contenu)
            let layoutActions = document.querySelectorAll('.acf-fc-layout-actions-wrap');
            
            // Si pas trouvé, chercher aussi dans les iframes (certains éditeurs utilisent des iframes)
            if (layoutActions.length === 0) {
                const iframes = document.querySelectorAll('iframe');
                iframes.forEach(function(iframe) {
                    try {
                        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                        const iframeActions = iframeDoc.querySelectorAll('.acf-fc-layout-actions-wrap');
                        if (iframeActions.length > 0) {
                            iframeActions.forEach(function(el) {
                                processLayoutActions(el);
                            });
                        }
                    } catch (e) {
                        // Ignorer les erreurs CORS
                    }
                });
            }
            
            if (layoutActions.length === 0) {
                // Essayer aussi avec d'autres sélecteurs possibles
                const alternativeSelectors = [
                    '.acf-fc-layout .acf-fc-layout-actions',
                    '.acf-flexible-content .acf-fc-layout-actions-wrap',
                    '[data-layout] .acf-fc-layout-actions-wrap'
                ];
                
                for (let i = 0; i < alternativeSelectors.length; i++) {
                    const elements = document.querySelectorAll(alternativeSelectors[i]);
                    if (elements.length > 0) {
                        elements.forEach(function(el) {
                            processLayoutActions(el);
                        });
                        return;
                    }
                }
                return;
            }
            
            layoutActions.forEach(function(actionsWrap) {
                processLayoutActions(actionsWrap);
            });
        }
        
        // Fonction pour traiter un élément actions-wrap
        function processLayoutActions(actionsWrap) {
            // Si l'élément a déjà un data-layout, c'est peut-être le layout lui-même
            if (actionsWrap.hasAttribute('data-layout')) {
                const layoutName = actionsWrap.getAttribute('data-layout');
                if (layoutName) {
                    addIconToElement(actionsWrap, layoutName);
                    return;
                }
            }
            
            // Vérifier si l'icône existe déjà
            if (actionsWrap.querySelector('.acf-block-preview-icon')) {
                return;
            }
            
            // Trouver le layout parent pour obtenir le nom du layout
            // Essayer plusieurs sélecteurs pour trouver le parent
            let layoutWrapper = actionsWrap.closest('.acf-fc-layout');
            if (!layoutWrapper) {
                layoutWrapper = actionsWrap.closest('[data-layout]');
            }
            if (!layoutWrapper) {
                // Chercher dans les parents
                let parent = actionsWrap.parentElement;
                while (parent && parent !== document.body) {
                    if (parent.hasAttribute('data-layout')) {
                        layoutWrapper = parent;
                        break;
                    }
                    parent = parent.parentElement;
                }
            }
            
            if (!layoutWrapper) {
                return;
            }
            
            // Le nom du layout est dans l'attribut data-layout
            const layoutName = layoutWrapper.getAttribute('data-layout');
            if (!layoutName) {
                return;
            }
            
            // Chercher le meilleur endroit pour insérer l'icône
            let targetElement = actionsWrap;
            
            // Si actionsWrap est le layout lui-même, chercher un header ou actions-wrap à l'intérieur
            if (actionsWrap === layoutWrapper) {
                targetElement = actionsWrap.querySelector('.acf-fc-layout-actions-wrap, .acf-fc-layout-header, .acf-fc-layout-actions');
                if (!targetElement) {
                    targetElement = actionsWrap;
                }
            }
            
            addIconToElement(targetElement, layoutName);
        }
        
        // Fonction pour ajouter l'icône à un élément
        function addIconToElement(targetElement, layoutName) {
            // Vérifier si l'icône existe déjà
            if (targetElement.querySelector('.acf-block-preview-icon')) {
                return;
            }
            
            
            const icon = document.createElement('span');
            icon.className = 'acf-block-preview-icon';
            icon.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/></svg>';
            icon.title = 'Aperçu du layout';
            
            let modalTimeout;
            let currentModal = null;
            
            icon.addEventListener('mouseenter', function(e) {
                clearTimeout(modalTimeout);
                // Supprimer le tooltip existant si il existe
                if (currentModal) {
                    currentModal.remove();
                    currentModal = null;
                }
                const tooltip = createPreviewTooltip(layoutName, true, icon);
                if (tooltip) {
                    // Le tooltip est déjà dans le DOM (ajouté temporairement pour calculer les dimensions)
                    // On le réajoute s'il a été retiré
                    if (!document.body.contains(tooltip)) {
                        document.body.appendChild(tooltip);
                    }
                    currentModal = tooltip;
                    
                    // Garder le tooltip ouvert quand on survole le tooltip
                    tooltip.addEventListener('mouseenter', function() {
                        clearTimeout(modalTimeout);
                    });
                    
                    tooltip.addEventListener('mouseleave', function() {
                        modalTimeout = setTimeout(function() {
                            if (currentModal) {
                                currentModal.remove();
                                currentModal = null;
                            }
                        }, 150);
                    });
                }
            });
            
            icon.addEventListener('mouseleave', function() {
                modalTimeout = setTimeout(function() {
                    if (currentModal && !currentModal.matches(':hover')) {
                        currentModal.remove();
                        currentModal = null;
                    }
                }, 150);
            });
            
            // Insérer l'icône dans l'élément cible
            if (targetElement) {
                // Essayer d'insérer dans .acf-fc-layout-actions-wrap s'il existe
                const actionsWrap = targetElement.querySelector('.acf-fc-layout-actions-wrap');
                if (actionsWrap) {
                    actionsWrap.appendChild(icon);
                } else {
                    // Sinon, insérer directement dans l'élément cible
                    targetElement.appendChild(icon);
                }
            }
        }

        // Observer les blocs existants et le panneau latéral
        function initBlocks() {
            // Chercher dans le panneau latéral (InspectorControls)
            const inspectorControls = document.querySelector('.block-editor-block-inspector .acf-block-component');
            if (inspectorControls) {
                // Trouver le bloc sélectionné
                const selectedBlock = wp.data.select('core/block-editor').getSelectedBlock();
                if (selectedBlock && selectedBlock.name && selectedBlock.name.startsWith('acf/')) {
                    setTimeout(function() {
                        addPreviewIcon(inspectorControls, selectedBlock.name);
                    }, 300);
                }
            }
            
            // Ajouter les icônes aux layouts flexibles
            addPreviewIconToLayouts();
        }

        // Attendre que ACF soit chargé
        function waitForACF(callback) {
            if (typeof acf !== 'undefined') {
                callback();
            } else {
                setTimeout(function() {
                    waitForACF(callback);
                }, 100);
            }
        }

        // Initialiser au chargement
        waitForACF(function() {
            setTimeout(function() {
                initBlocks();
                addPreviewIconToLayouts();
            }, 500);
        });

        // Observer les changements dans le panneau latéral
        const sidebarObserver = new MutationObserver(function() {
            initBlocks();
            // Ajouter les icônes aux layouts flexibles à chaque changement
            setTimeout(addPreviewIconToLayouts, 100);
        });

        const sidebar = document.querySelector('.interface-complementary-area');
        if (sidebar) {
            sidebarObserver.observe(sidebar, {
                childList: true,
                subtree: true
            });
        }
        
        // Observer pour détecter l'ouverture du popup de sélection de layout
        const popupObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {
                        // Vérifier si c'est le popup qui s'ouvre
                        if (node.classList && (node.classList.contains('acf-tooltip') || node.classList.contains('acf-fc-popup'))) {
                            setTimeout(function() {
                                addPreviewIconsToPopup();
                            }, 50);
                        }
                        
                        // Vérifier si le popup est dans le node
                        const popup = node.querySelector ? node.querySelector('.acf-tooltip.acf-fc-popup') : null;
                        if (popup) {
                            setTimeout(function() {
                                addPreviewIconsToPopup();
                            }, 50);
                        }
                    }
                });
            });
        });
        
        // Observer le body pour détecter l'apparition du popup
        popupObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        // Vérifier périodiquement si le popup est ouvert
        setInterval(function() {
            addPreviewIconsToPopup();
        }, 500);
        
        // Écouter les événements ACF pour détecter l'ouverture du popup
        if (typeof acf !== 'undefined' && acf.addAction) {
            // Quand un champ flexible content est rendu
            acf.addAction('render_field', function(field) {
                if (field && field.type === 'flexible_content') {
                    setTimeout(function() {
                        addPreviewIconsToPopup();
                    }, 200);
                }
            });
            
            // Écouter les clics sur les boutons d'ajout de layout
            document.addEventListener('click', function(e) {
                if (e.target && (e.target.classList.contains('acf-button') || e.target.closest('.acf-button'))) {
                    setTimeout(function() {
                        addPreviewIconsToPopup();
                    }, 300);
                }
            });
        }
        
        // Écouter les événements ACF pour détecter l'ouverture du popup
        if (typeof acf !== 'undefined' && acf.addAction) {
            // Quand un champ flexible content est rendu
            acf.addAction('render_field', function(field) {
                if (field && field.type === 'flexible_content') {
                    setTimeout(function() {
                        addPreviewIconsToPopup();
                    }, 200);
                }
            });
            
            // Écouter les clics sur les boutons d'ajout de layout
            document.addEventListener('click', function(e) {
                if (e.target && (e.target.classList.contains('acf-button') || e.target.closest('.acf-button'))) {
                    setTimeout(function() {
                        addPreviewIconsToPopup();
                    }, 300);
                }
            });
        }
        
        // Observer spécifiquement les layouts flexibles avec un délai
        const layoutObserver = new MutationObserver(function(mutations) {
            let shouldCheck = false;
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) {
                            // Vérifier si un layout flexible a été ajouté
                            if (node.classList && (
                                node.classList.contains('acf-fc-layout') ||
                                node.classList.contains('acf-fc-layout-actions-wrap') ||
                                node.querySelector('.acf-fc-layout') ||
                                node.querySelector('.acf-fc-layout-actions-wrap')
                            )) {
                                shouldCheck = true;
                            }
                        }
                    });
                }
            });
            if (shouldCheck) {
                setTimeout(addPreviewIconToLayouts, 100);
            }
        });
        
        // Observer le document entier pour les layouts flexibles
        layoutObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        // Écouter les événements ACF pour les layouts flexibles
        if (typeof acf !== 'undefined' && acf.addAction) {
            // Quand un layout flexible est ajouté
            acf.addAction('new_field/flexible_content', function() {
                setTimeout(addPreviewIconToLayouts, 300);
            });
            
            // Quand un layout est rendu
            acf.addAction('render_field', function(field) {
                if (field && field.type === 'flexible_content') {
                    setTimeout(addPreviewIconToLayouts, 300);
                }
            });
        }
        
        // Forcer une vérification périodique (fallback) - moins fréquent
        setInterval(function() {
            addPreviewIconToLayouts();
        }, 5000);

        // Écouter les changements de bloc sélectionné
        if (wp.data && wp.data.subscribe) {
            wp.data.subscribe(function() {
                setTimeout(initBlocks, 300);
            });
        }

        // Observer les changements dans l'éditeur pour les nouveaux blocs
        const editorContainer = document.querySelector('.block-editor-writing-flow');
        if (editorContainer) {
            observer.observe(editorContainer, {
                childList: true,
                subtree: true
            });
        }
    }
    
    // Initialiser dans Gutenberg
    if (typeof wp !== 'undefined' && typeof wp.domReady !== 'undefined') {
        wp.domReady(function() {
            initACFBlockPreview();
        });
    } else {
        // Initialiser dans l'admin classique
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                initACFBlockPreview();
            });
        } else {
            initACFBlockPreview();
        }
        
        // Attendre que ACF soit chargé
        if (typeof acf !== 'undefined') {
            acf.addAction('ready', function() {
                setTimeout(initACFBlockPreview, 500);
            });
        }
    }
})();

